/**
 * Represents the base types of CopilotLicenseType and ICheckCopilotLicenseSignal interfaces in server-side,
 */
export var CopilotLicenseType;
(function (CopilotLicenseType) {
    CopilotLicenseType[CopilotLicenseType["Unknown"] = 0] = "Unknown";
    CopilotLicenseType[CopilotLicenseType["CopilotInM365"] = 1] = "CopilotInM365";
    CopilotLicenseType[CopilotLicenseType["CopilotPro"] = 2] = "CopilotPro";
    CopilotLicenseType[CopilotLicenseType["CopilotEnterprise"] = 3] = "CopilotEnterprise";
})(CopilotLicenseType || (CopilotLicenseType = {}));
//# sourceMappingURL=copilot-licensing.js.map